import { proxy } from 'valtio'
import type { StoredCourse } from '../../shared/lib/appLocalStorage.ts'
import { AppLocalStorage } from '../../shared/lib/appLocalStorage.ts'
import { AppLanguages, languages } from '../../shared/translations/messages.ts'
import { GeoIp } from 'src/shared/api/authApi.ts'

interface State {
  edmanUnmute: boolean
  hideMenu: boolean
  language: AppLanguages
  uiLocale: AppLanguages
  geoIp: GeoIp | null
}

export class AppStore {
  state: State

  constructor(private appLocalStorage: AppLocalStorage) {
    const course = this.appLocalStorage.get('currentCourse')
    this.state = proxy<State>({
      edmanUnmute: false,
      hideMenu: false,
      language: this.getInitialLanguage(),
      uiLocale: this.getUiLocaleFromCourse(course ?? undefined),
      geoIp: null,
    })
  }

  private getUiLocaleFromCourse(
    course: StoredCourse | null | undefined,
  ): AppLanguages {
    return course?.frontend_locale === 'RU' ? 'ru' : 'en'
  }

  syncUiLocaleFromStorage() {
    const course = this.appLocalStorage.get('currentCourse')
    this.state.uiLocale = this.getUiLocaleFromCourse(course ?? undefined)
  }

  setHideMenu(value: boolean) {
    this.state.hideMenu = value
  }

  getInitialLanguage() {
    return 'en' as AppLanguages
  }

  setLanguage(language: AppLanguages) {
    this.state.language = 'en'
    this.appLocalStorage.set('language', 'en')
  }

  setGeoIp(geoIp: GeoIp) {
    this.state.geoIp = geoIp
  }

  toggleEdmanUnmute() {
    this.state.edmanUnmute = !this.state.edmanUnmute
  }
}
